import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { officesGroupsAge } from '../../../../constants/group_constant';

const StudentAgeGroup = ({ value }) => {
    const { t } = useTranslation();

    const ageKey = officesGroupsAge[value];
    const translatedAge = ageKey !== undefined ? t(ageKey) : '-';

    return <Typography variant="body1">{translatedAge}</Typography>;
};

export default StudentAgeGroup;
